import { useTranslation } from "react-i18next";
import { SearchX, Play, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useTour } from "@/hooks/useTour";

export const HelpEmpty = () => {
	const { t } = useTranslation();
	const tour = useTour();
	const supportEmail = t("help.actions.supportEmail");

	return (
		<Card>
			<CardContent className="flex flex-col items-center text-center py-12 px-6">
				<SearchX className="h-12 w-12 text-muted-foreground mb-4" />
				<h3 className="text-lg font-semibold mb-1">{t("help.search.noResultsTitle")}</h3>
				<p className="text-sm text-muted-foreground max-w-md mb-6">
					{t("help.search.noResultsDescription")}
				</p>
				<div className="flex flex-wrap items-center justify-center gap-2">
					<Button variant="outline" onClick={tour.start}>
						<Play className="h-4 w-4 mr-2" />
						{t("help.actions.restartTour")}
					</Button>
					<Button variant="outline" asChild>
						<a href={`mailto:${supportEmail}`}>
							<Mail className="h-4 w-4 mr-2" />
							{t("help.actions.contactSupport")}
						</a>
					</Button>
				</div>
			</CardContent>
		</Card>
	);
};
